import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordNavigation } from "@common/utils/diagnostics";

/**
 * The screen history a bug report carries: one entry per section, on every
 * change of location, so deep links and back/forward count too. Mounted once
 * inside the router, above the routes, so it covers the player as well.
 */
export default function NavRecorder() {
  const section = useLocation().pathname.split("/")[1] || "home";
  useEffect(() => recordNavigation(section), [section]);
  return null;
}
